<template>
<div>
    <b-row>
        <b-colxx xxs="12">
            <b-card class="mb-4" title="매장 콘텐츠">
                <b-form-group label-cols="2" horizontal label="메인 이미지" class="weight600">
                    <b-form-row>
                        <sortable-file-uploader :sortable="'hold'" :container="'STORE'" :compact="true" :maxFiles="1" :defaultFiles="tempMainContent" @getFileData="getMainFile"></sortable-file-uploader>
                    </b-form-row>
                </b-form-group>
              <b-form-group v-if="kakaoId" label-cols="2" horizontal class="weight600">
                <template v-slot:label>장소 대표 이미지<br>(카카오톡 예약하기 전용)</template>
                <b-form-row>
                  <sortable-file-uploader :sortable="'hold'" :container="'STORE'" :compact="true" :maxFiles="1" :defaultFiles="tempKakaoContent" @getFileData="getKakaoFile"></sortable-file-uploader>
                </b-form-row>
                <b-form-row class="mt-1">
                  <ul class="text-muted image-description">
                    <li>권장 사이즈 800x800px / 파일당 최대 20MB / jpeg, jpg, png, gif</li>
                    <li>상호명, 간판, 로고, 매장 사진 등 장소 관련 이미지로 등록해 주세요.</li>
                    <li>미등록 시 매장 기본정보에 등록된 대표이미지로 대체되어 등록됩니다.</li>
                  </ul>
                </b-form-row>
              </b-form-group>

                <b-form-group label-cols="2" horizontal label="서브 이미지" class="weight600" style="display:none">
                    <b-form-row>
                        <store-file-uploader :sortable="'handle'" :container="'STORE'" :compact="false" :maxFiles="10" :defaultFiles="tempSubContent" @getFileData="getSubFiles"></store-file-uploader>
                    </b-form-row>
                </b-form-group>

                <b-form-group label-cols="2" horizontal label="메뉴판 이미지" class="weight600">
                    <b-form-row>
                        <store-file-uploader :sortable="'handle'" :container="'STORE'" :compact="false" :maxFiles="10" :defaultFiles="tempMenupanContent" @getFileData="getMenupanFiles"></store-file-uploader>
                    </b-form-row>
                </b-form-group>

                <!-- <b-form-group label-cols="2" horizontal label="홍보 동영상" class="weight600" >
                    <b-form-input v-model="fileForm.promotionVideoUrl" placeholder="홍보 동영상 URL"></b-form-input>
                </b-form-group> -->
                <b-form-group label-cols="2" horizontal label="매장 한줄 소개" class="weight600">
                    <b-form-input v-model="fileForm.mainIntro" placeholder="" maxlength="40" @keyup="mainIntroLength($event,fileForm.mainIntro)"></b-form-input>
                    <span class="mainIntroNum" v-if="fileForm.mainIntro">{{ fileForm.mainIntro.length }} / 40 자</span>
                    <span v-else></span>
                    <!-- <b-form-textarea v-model="fileForm.mainIntro" :rows="1" :max-rows="1" /> -->
                </b-form-group>
                <b-form-group label-cols="2" horizontal label="매장 상세 소개" class="weight600">
                    <b-form-textarea v-model="storeIntroduction" :rows="4" :max-rows="4" maxlength="2000" @keyup="storeIntroductionLength"/>
                    <span class="mainIntroNum" v-if="storeIntroduction">{{ storeIntroduction.length }} / 2000 자</span>
                    <span v-else></span>
                </b-form-group>
                <b-form-group label-cols="2" horizontal label="이용안내" class="weight600">
                  <b-form-textarea v-model="useInformation" :rows="4" :max-rows="4" maxlength="2000" @keyup="storeIntroductionLength"/>
                  <span class="mainIntroNum" v-if="useInformation">{{ useInformation.length }} / 2000 자</span>
                  <span v-else></span>
                </b-form-group>
                <b-form-group label-cols="2" horizontal label="유의사항" class="weight600">
                    <b-form-textarea v-model="fileForm.notice" :rows="5" :max-rows="5" maxlength="2000"/>
                  <span class="mainIntroNum" v-if="fileForm.notice">{{ fileForm.notice.length }} / 2000 자</span>
                  <span v-else></span>
                </b-form-group>


                <div class="text-center">
                    <b-button variant="primary" @click.prevent="onSaveFiles">저장</b-button>
                </div>
            </b-card>
        </b-colxx>
    </b-row>

    <b-row>
        <b-colxx xxs="12">
            <b-card class="mb-4" title="매장 이미지">
                <b-form-group label-cols="2" horizontal label="매장 이미지" class="weight600">
                    <StoreImg ref="strimg" @get-kakao-alert="getKakaoAlert" />
                </b-form-group>

                <div class="text-center">
                    <!-- <b-button variant="primary" @click="strimgClick">저장</b-button> -->
                </div>
            </b-card>
        </b-colxx>
    </b-row>

    <b-row>
        <b-colxx xxs="12">
            <b-card class="mb-4" title="영업 정보">
                <b-form-group label-cols="2" horizontal label="영업 시간" class="weight600">
                    <business-hour class="mb-2" v-for="(openingHour, index) in form.openingHours" :key="openingHour.id" :data="openingHour" :breakTimeFlag="false" @changeData="changeOpeningHour" @delete-business-hour="deleteOpeningHour"></business-hour>
                    <b-row align-v="center" class="justify-content-start" no-gutters>
                        <b-button variant="outline-success" class="mt-2" size="sm" @click.prevent="addOpeningHour()">영업시간 추가
                        </b-button>
                    </b-row>
                </b-form-group>

                <b-form-group label-cols="2" horizontal label="휴식 시간" class="mt-2 mb-2 weight600">
                    <business-hour class="mb-2" v-for="(breakTime, index) in form.breakTimes" :key="breakTime.id" :data="breakTime" :breakTimeFlag="true" @changeData="changeBreakTime" @delete-business-hour="deleteBreakTime"></business-hour>
                    <b-row align-v="center" class="justify-content-start" no-gutters>
                        <b-button variant="outline-success" class="mt-2" size="sm" @click.prevent="addBeakTime()">시간 추가</b-button>
                    </b-row>
                </b-form-group>

                <b-form-group label-cols="2" horizontal label="주말설정" class="weight600">
                    <b-row align-v="center" class="justify-content-start m-1" no-gutters>
                        <span class="mt-2">시작 요일</span>
                        <b-col cols="1" class="ml-2">
                            <b-form-select class="mt-2" v-model="startDayOfWeek" :options="weekdayOptions" plain />
                        </b-col>
                    </b-row>

                    <b-row align-v="center" class="justify-content-start m-1" no-gutters>
                        <span class="mt-2">종료 요일</span>
                        <b-col cols="1" class="ml-2">
                            <b-form-select class="mt-2" v-model="endDayOfWeek" :options="weekdayOptions" plain />
                        </b-col>
                    </b-row>

                </b-form-group>

                <b-form-group label-cols="2" horizontal label="주말에 공휴일 포함 여부" class="weight600">
                    <b-row align-v="center" class="justify-content-start m-1" no-gutters>
                        <b-col md="auto">
                            <b-form-radio-group v-model="includeNationalHoliday">
                                <b-form-radio value="true">포함함</b-form-radio>
                                <b-form-radio value="false">포함하지 않음</b-form-radio>
                            </b-form-radio-group>
                        </b-col>
                    </b-row>
                </b-form-group>

                <b-form-group label-cols="2" horizontal label="편의시설" class="weight600">
                    <b-row>
                        <b-col cols="12" class="ml">
                          <div v-for="(item,idx) in amenity" :key="idx" class="custom-control custom-checkbox displayin col-2">
                            <input autocomplete="off" type="checkbox" v-model="item.checked" :id="item.id" :value="item.id" class="amenity custom-control-input" :checked="item.checked">
                            <label class="custom-control-label" :for="item.id">
                                {{ item.amenityName }}
                            </label>
                            </div>
                        </b-col>
                    </b-row>
                </b-form-group>
                <div class="text-center">
                    <b-button variant="primary" class="mt-4" @click.prevent="onSave">저장</b-button>
                </div>
            </b-card>
        </b-colxx>
    </b-row>

    <b-button variant="outline-primary" class="mt-0" @click.prevent="onCancel">뒤로</b-button>
</div>
</template>

<script>
import {
    rescode,
} from "../../../constants/common";
import {
    reqGet,
    reqPost
} from "../../../constants/request";
import 'vue-select/dist/vue-select.css'
import {
    mapGetters,
    mapActions
} from "vuex";
import api from '../../../constants/api'
import SortableFileUploader from "../../../components/Upload/SortableFileUploader.vue";
import StoreFileUploader from "../../../components/Upload/StoreFileUploader.vue";
import BusinessHour from "../../../components/Business/BusinessHour.vue";
import StoreImg from '../components/StoreImg.vue';

export default {
    components: {
        'sortable-file-uploader': SortableFileUploader,
        'store-file-uploader': StoreFileUploader,
        'business-hour': BusinessHour,
        StoreImg
    },
    data() {
        return {
            storeIntroductionNum:0,
            mainIntroNum:0,
            amenityId: [],
            amenity:[],
            userRole: null,
            storeIntroduction: null,
            tempMainContent: [],
            tempSubContent: [],
            tempMenupanContent: [],
            tempKakaoContent: [],
            storeCode: this.$route.params.storeCode,
            openingHourId: 0,
            breakTimeId: 0,
            form: {
                openingHours: [],
                breakTimes: [],
                amenitiesInfo: {
                    amenityId: []
                },

                facilities: "",
            },
            fileForm: {
                mainIntro:'',
                mainFile: [],
                notice:'',
                mainImageUrl: [],
                subFiles: [],
                subImageUrls: [],
                menupanImages:[],
                kakaoImageUrl: [],
                // promotionVideoUrl: ""

            },
            radioOptions: [{
                    text: "불가능",
                    value: false
                },
                {
                    text: "가능",
                    value: true
                }
            ],
            showPromotionVideo: false,
            includeNationalHoliday: false,
            startDayOfWeek: 1,
            startHourOfStartDay: null,
            endDayOfWeek: 7,
            endHourOfEndDay: null,
            weekdayOptions: [{
                    value: 1,
                    text: '월'
                },
                {
                    value: 2,
                    text: '화'
                },
                {
                    value: 3,
                    text: '수'
                },
                {
                    value: 4,
                    text: '목'
                },
                {
                    value: 5,
                    text: '금'
                },
                {
                    value: 6,
                    text: '토'
                },
                {
                    value: 7,
                    text: '일'
                }
            ],
            hourOfDayOptions: [{
                    value: null,
                    text: '종일'
                },
                {
                    value: '00',
                    text: '00 시'
                },
                {
                    value: '01',
                    text: '01 시'
                },
                {
                    value: '02',
                    text: '02 시'
                },
                {
                    value: '03',
                    text: '03 시'
                },
                {
                    value: '04',
                    text: '04 시'
                },
                {
                    value: '05',
                    text: '05 시'
                },
                {
                    value: '06',
                    text: '06 시'
                },
                {
                    value: '07',
                    text: '07 시'
                },
                {
                    value: '08',
                    text: '08 시'
                },
                {
                    value: '09',
                    text: '09 시'
                },
                {
                    value: '10',
                    text: '10 시'
                },
                {
                    value: '11',
                    text: '11 시'
                },
                {
                    value: '12',
                    text: '12 시'
                },
                {
                    value: '13',
                    text: '13 시'
                },
                {
                    value: '14',
                    text: '14 시'
                },
                {
                    value: '15',
                    text: '15 시'
                },
                {
                    value: '16',
                    text: '16 시'
                },
                {
                    value: '17',
                    text: '17 시'
                },
                {
                    value: '18',
                    text: '18 시'
                },
                {
                    value: '19',
                    text: '19 시'
                },
                {
                    value: '20',
                    text: '20 시'
                },
                {
                    value: '21',
                    text: '21 시'
                },
                {
                    value: '22',
                    text: '22 시'
                },
                {
                    value: '23',
                    text: '23 시'
                },
            ],

          useInformation:"",
          kakaoId:0
        }
    },
    computed: {
        ...mapGetters(['currentUser', 'siteName'])
    },
    mounted() {
        this.userRole = this.currentUser.userRole.split('_')[0]
        this.loadRunningInfo()
        this.loadData();
    },

    watch: {},
    methods: {
        mainIntroLength(eve){
            this.mainIntroNum = eve.srcElement._value.length
        },
        storeIntroductionLength(eve){
            this.storeIntroductionNum = eve.srcElement._value.length
        },
        strimgClick() {
            this.$refs.strimg.storeImagesUpdate()
        },
        /** **************************************************************************************************************/
        /** 매장 콘텐츠                                                                                                   */
        /** **************************************************************************************************************/

        //콘텐츠 정보 조회
        loadData: function () {
            let reqURL = ''

            if (this.userRole == "BRAND") {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.contents)
            } else {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.contentsStr)
            }

            const params = {
                storeCode: this.storeCode
            }

            this.$http.get(reqURL, {
                params: params,
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    const _data = res.data.data.siteContents

                    this.fileForm.mainImageUrl = _data.mainImage
                    this.storeIntroduction = _data.storeIntroduction
                    this.fileForm.mainIntro = _data.mainIntro;
                    this.fileForm.notice = _data.notice;
                    this.useInformation = _data.useInformation;
                    this.kakaoId = _data.kakaoId

                    this.$emit('get-kakao-id',this.kakaoId)

                    this.tempMainContent.push({
                        "name": "TestName.jpg",
                        "size": 20000,
                        "type": "image/jpeg",
                        "ext": "jpg",
                        "url": this.fileForm.mainImageUrl.url,
                        "height": this.fileForm.mainImageUrl.height,
                        "width": this.fileForm.mainImageUrl.width
                    })

                    this.fileForm.subImageUrls = _data.subImages;
                    this.fileForm.menupanImages = _data.menupanImages;
                    let tmpFileUrl = _data.kakaoImageUrl
                    this.fileForm.kakaoImageUrl.push(
                      {
                        url: tmpFileUrl,
                        height: 600,
                        width: 400
                      }
                    );

                    const vm = this

                    this.fileForm.subImageUrls.forEach(function (val, index) {
                        vm.tempSubContent.push({
                            "name": "TestName.jpg",
                            "size": 20000,
                            "type": "image/jpeg",
                            "ext": "jpg",
                            "url": val.url,
                            "height": val.height,
                            "width": val.width
                        })
                    })


                    this.fileForm.menupanImages.forEach(function (val, index) {
                        vm.tempMenupanContent.push({
                            "name": "TestName.jpg",
                            "size": 20000,
                            "type": "image/jpeg",
                            "ext": "jpg",
                            "url": val.url,
                            "height": val.height,
                            "width": val.width
                        })
                    })

                  this.tempKakaoContent.push({
                    "name": "TestName.jpg",
                    "size": 20000,
                    "type": "image/jpeg",
                    "ext": "jpg",
                    "url": this.fileForm.kakaoImageUrl[0].url,
                    "height": this.fileForm.kakaoImageUrl[0].height,
                    "width": this.fileForm.kakaoImageUrl[0].width
                  })

                    // this.fileForm.promotionVideoUrl = _data.promotionVideoUrl

                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
                // this.$router.back()
            })

        },

        getMainFile(file) { //이미지 파일 목록 SortableFileUploader 에서 넘겨줌
            // this.fileForm.mainImageUrl = fileData
            console.log("getMainFile", file)

            if (file.length > 0) {
                let _url = file[0].azureUrl ? file[0].azureUrl : file[0].url;
                this.fileForm.mainImageUrl = {
                    width: file[0].width,
                    height: file[0].height,
                    url: _url,
                    azureUrl: _url
                }
            } else {
                this.fileForm.mainImageUrl = null
            }

        },
      getKakaoFile(file) { //이미지 파일 목록 SortableFileUploader 에서 넘겨줌
        // this.fileForm.mainImageUrl = fileData

        if (file.length > 0) {
          let _url = file[0].azureUrl ? file[0].azureUrl : file[0].url;
          this.fileForm.kakaoImageUrl = {
            width: file[0].width,
            height: file[0].height,
            url: _url,
            azureUrl: _url
          }
        } else {
          this.fileForm.kakaoImageUrl = null
        }

      },

        getSubFiles(fileData) { //서브이미지 파일 목록 SortableFileUploader 에서 넘겨줌
            // this.fileForm.subFiles = fileData

            if (fileData.length > 0) {
                let vm = this
                this.fileForm.subImageUrls = []

                fileData.forEach(function (value, index) {
                    let _url = value.azureUrl ? value.azureUrl : value.url;

                    vm.fileForm.subImageUrls.push({
                        width: value.width,
                        height: value.height,
                        url: _url,
                        azureUrl: _url
                    })
                })

            } else {
                this.fileForm.subImageUrls = []
            }

        },
        getMenupanFiles(fileData) { //서브이미지 파일 목록 SortableFileUploader 에서 넘겨줌
            // this.fileForm.subFiles = fileData

            if (fileData.length > 0) {
                let vm = this
                this.fileForm.menupanImages = []

                fileData.forEach(function (value, index) {
                    let _url = value.azureUrl ? value.azureUrl : value.url;

                    vm.fileForm.menupanImages.push({
                        width: value.width,
                        height: value.height,
                        url: _url,
                        azureUrl: _url
                    })
                })

            } else {
                this.fileForm.menupanImages = []
            }

        },

        //매장콘텐츠 변경
        onSaveFiles() {
            console.log(this.fileForm.mainFile.length, this.fileForm.mainImageUrl);

            if (this.fileForm.mainFile.length === 0 && this.fileForm.mainImageUrl === null) {
                alert('메인 이미지를 등록해 주세요.')
                return false
            }

            // if (this.fileForm.subFiles.length === 0 && (this.fileForm.subImageUrls.length === 0)) {
            //     alert('서브이미지를 1개 이상 등록해 주세요.')
            //     return false
            // }

            let reqURL = ''
            if (this.userRole == "BRAND") {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.contentsUpdate)
            } else {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.contentsUpdateStr)
            }

            const params = {
                siteContents: {
                    storeIntroduction: this.storeIntroduction,
                    mainIntro:this.fileForm.mainIntro,
                    notice:this.fileForm.notice,
                    mainImage: {
                        url: this.fileForm.mainImageUrl.url,
                        width: this.fileForm.mainImageUrl.width,
                        height: this.fileForm.mainImageUrl.height
                    },
                    subImages: this.fileForm.subImageUrls,
                    menupanImages: this.fileForm.menupanImages,
                    useInformation:this.useInformation,
                    kakaoImageUrl : this.fileForm.kakaoImageUrl.url,
                    // promotionVideoUrl: this.fileForm.promotionVideoUrl
                },
                storeCode: this.storeCode
            }

            console.log(params)

            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                  if(this.kakaoId) {
                    this.$emit('get-kakao-alert', 'STORE');
                  }
                    alert('변경하였습니다.')
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })

        },

        /** **************************************************************************************************************/
        /** 영업정보                                                                                                     */
        /** **************************************************************************************************************/

        loadRunningInfo() {

            let reqURL = ''
            if (this.userRole == "BRAND") {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.businessInfo)
            } else {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.businessInfoStr)
            }

            const params = {
                storeCode: this.storeCode
            };

            this.$http.get(reqURL, {
                params: params,
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    // console.log("영업정보", res.data)
                    this.loadRunningInfoCallback(res.data.data)
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })
        },

        async loadRunningInfoCallback(data) {
            const vm = this

            data.openingHours.forEach((Value, Index) => {
                if (Value.openingHourType == "BreakTime") {
                    vm.form.breakTimes.push(Value)
                } else {
                    vm.form.openingHours.push(Value)
                }
            });

            this.form.openingHours.forEach((Value, Index) => {
                this.form.openingHours[Index].id = Index
            });
            this.openingHourId = this.form.openingHours.length

            this.form.breakTimes.forEach((Value, Index) => {
                this.form.breakTimes[Index].id = Index
            });
            this.breakTimeId = this.form.breakTimes.length

            //주말설정
            this.startDayOfWeek = data.weekendSettings.startDayOfWeek
            // this.startHourOfStartDay = data.weekendSettings.startHourOfStartDay
            this.endDayOfWeek = data.weekendSettings.endDayOfWeek
            // this.endHourOfEndDay = data.weekendSettings.endHourOfEndDay
            this.includeNationalHoliday = data.weekendSettings.includeNationalHoliday;

            this.amenityId = data.amenitiesInfo.amenityId; //편의 시설 안내

            this.getamenity();
            //어메니티
            // this.form.facilities = data.amenitiesInfo.amenitiesDetails

        },
        getamenity() {
            reqGet(
                this.requrlChange(api.shop.storeAmenityList, api.shop.storeAmenityList, '',''),
                this.currentUser.tokens.access.token,
                (result) => {
                    if (result != null) {
                        if (result.code == rescode.REQ_SUCCESS) {
                            this.amenity = [];
                            let newAmenity = [];
                            result.data.forEach(el => {
                                if (el.enabled) {
                                    newAmenity.push(el)
                                }
                            });
                            let vm = this;
                            vm.amenity = newAmenity;
                            let nenen = [];
                            this.amenity.forEach(el => {
                                let newam = {
                                    checked: false,
                                    id: el.id,
                                    enabled: el.enabled,
                                    registeredDate: el.registeredDate,
                                    amenityName: el.amenityName,
                                }
                                nenen.push(newam);
                            });
                            vm.amenityId.forEach((el, idx) => {
                                vm.amenity.forEach((am, adx) => {

                                    if (el === am.id) {
                                        nenen[adx].checked = true;
                                    }
                                });
                            });
                            this.amenity = nenen;
                            // console.log(nenen)
                        } else {
                            alert(result.message);
                        }
                    }
                }
            );
        },
        requrlChange(brdapiName, strapiName, brdquerystring, strquerystring) {
            let reqURL = ''
            if (this.currentUser.userRole.split('_')[0] == "BRAND") {
                reqURL = api.changeAPI(this.siteName, api.basicURL + brdapiName) + brdquerystring
            } else {
                reqURL = api.changeAPI(this.siteName, api.basicURL + strapiName) + strquerystring
            }
            return reqURL
        },
        //영업 시간 추가
        addOpeningHour() {
            this.form.openingHours.push({
                id: this.openingHourId++,
                dayOfWeekType: null,
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
                openingHourType: null,
                timeFrom: null,
                timeTo: null,
                comment: null
            })
        },

        deleteOpeningHour(id) { //영업 시간 삭제 business-hour 에서 이벤트 받아옴
            this.form.openingHours = this.form.openingHours.filter(item => item.id !== id)
        },

        changeOpeningHour(key, object) { // 영업시간 내용 변경 business-hour 에서 이벤트 받아옴
            const index = this.form.openingHours.findIndex(item => item.id === key)
            this.form.openingHours[index] = object
        },

        addBeakTime() { // 쉬는시간 추가
            this.form.breakTimes.push({
                id: this.breakTimeId++,
                dayOfWeekType: null,
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
                openingHourType: 'BreakTime',
                timeFrom: null,
                timeTo: null,
                comment: null
            })
        },

        deleteBreakTime(id) { // 쉬는 시간 삭제  business-hour 에서 이벤트 받아옴
            this.form.breakTimes = this.form.breakTimes.filter(item => item.id !== id)
        },

        changeBreakTime(key, object) { // 쉬는 시간  business-hour 에서 이벤트 받아옴
            const index = this.form.breakTimes.findIndex(item => item.id === key)
            this.form.breakTimes[index] = object
        },

        // 영업정보 저장
        onSave() {
            //영업시간, 주말설정
            let amArry = [];
            this.amenity.forEach(am => {
              if(am.checked === true){
                amArry.push(am.id)
              }
            });
            if(amArry.length === 0){
              alert('편의시설을 선택해주세요.');
              return
            }
            const openingHoursArr = []
            // console.log(amArry);

            if (this.form.openingHours.length < 1) {
                alert("영업시간을 입력하세요.")
                return
            }

            var flag = true
            this.form.openingHours.forEach((Value, Index) => {
                if (Value.dayOfWeekType == null) {
                    flag = false
                }
                if (Value.openingHourType == null) {
                    flag = false
                } else if (Value.openingHourType == "RunningTime") {
                    if (Value.timeFrom == "" || Value.timeTo == "") {
                        flag = false
                    }
                }
                if (!flag) {
                    alert("영업시간을 확인해주세요.")
                    return
                }
                const val = {
                    "dayOfWeekType": Value.dayOfWeekType,
                    "monday": Value.monday,
                    "tuesday": Value.tuesday,
                    "wednesday": Value.wednesday,
                    "thursday": Value.thursday,
                    "friday": Value.friday,
                    "saturday": Value.saturday,
                    "sunday": Value.sunday,
                    "openingHourType": Value.openingHourType,
                    "timeFrom": Value.timeFrom,
                    "timeTo": Value.timeTo,
                    "comment": Value.comment

                }
                openingHoursArr.push(val)
            });

            this.form.breakTimes.forEach((Value, Index) => {
                const val = {
                    "dayOfWeekType": Value.dayOfWeekType,
                    "monday": Value.monday,
                    "tuesday": Value.tuesday,
                    "wednesday": Value.wednesday,
                    "thursday": Value.thursday,
                    "friday": Value.friday,
                    "saturday": Value.saturday,
                    "sunday": Value.sunday,
                    "openingHourType": Value.openingHourType,
                    "timeFrom": Value.timeFrom,
                    "timeTo": Value.timeTo,
                    "comment": Value.comment
                }
                openingHoursArr.push(val)
            });

            let params = {
                openingHours: openingHoursArr,
                weekendSettings: {
                    startDayOfWeek: this.startDayOfWeek,
                    // startHourOfStartDay: this.startHourOfStartDay,
                    endDayOfWeek: this.endDayOfWeek,
                    // endHourOfEndDay: this.endHourOfEndDay,
                    includeNationalHoliday: this.includeNationalHoliday
                },
                amenitiesInfo: {
                    amenityId: amArry,
                },
                storeCode: this.storeCode
            }

            if (params.weekendSettings.startDayOfWeek == null || params.weekendSettings.endDayOfWeek == null) {
                alert("주말설정을 입력하세요.")
                return
            }

            // if (params.amenitiesInfo.amenitiesDetails == null) {
            //     alert("편의시설을 입력하세요.")
            //     return
            // }

            if (params.weekendSettings.includeNationalHoliday == null) {
                alert("주말에 공휴일 포함 여부를 입력하세요.")
                return
            }

            console.log(params);

            let reqURL = ''
            if (this.userRole == "BRAND") {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.businessInfoUpdate)
            } else {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.businessInfoUpdateStr)
            }

            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    this.$emit('get-kakao-alert', 'STORE');
                    alert('변경하였습니다.')
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            });
        },

        //뒤로버튼
        onCancel() {
            this.$router.back();
        },
        getKakaoAlert(val){
          this.$emit('get-kakao-alert', 'STORE');
        }
        // playPromotionVideo() {
        //   this.showPromotionVideo = true;
        // },
    }
}
</script>

<style scoped>

span.mainIntroNum {position: absolute;bottom: 4px;right: 18px;color: #919191;font-size: 12px;}

.image-description {
  padding-inline-start: 20px;
  margin-block-end: 0;
}

</style>
